import React from "react";
import { useTranslation } from "react-i18next";
import useLangNavigate from "../../hooks/useLangNavigate";
import OffoodLogo from "../brand/OffoodLogo";
import Button from "../buttons/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedinIn,
  faInstagram,
  faFacebookF,
  faGooglePlay,
  faApple,
} from "@fortawesome/free-brands-svg-icons";
import { playStoreUrl, appStoreUrl } from "../../utils/constants";

function LandingFooter() {
  const { t } = useTranslation();
  const navigate = useLangNavigate();

  return (
    <footer className="landing-footer">
      <div className="landing-footer__container">
        <div className="landing-footer__top">
          <div className="landing-footer__brand">
            <OffoodLogo width="120px" variant="white" />
            <p className="landing-footer__tagline">
              {t("landing.footer.tagline")}
            </p>
            <div className="flex gap-1 mt-2">
              <Button
                className="store-button"
                variant="light"
                size="sm"
                onClick={() => window.open(playStoreUrl, "_blank")}
              >
                <FontAwesomeIcon icon={faGooglePlay} color="black" size="lg" />
                <div className="text-left">
                  <p className="p4">{t("home.google.download")}</p>
                  <p className="p3">{t("home.google.store")}</p>
                </div>
              </Button>
              <Button
                className="store-button"
                variant="light"
                size="sm"
                onClick={() => window.open(appStoreUrl, "_blank")}
              >
                <FontAwesomeIcon icon={faApple} color="black" size="lg" />
                <div className="text-left">
                  <p className="p4">{t("home.apple.download")}</p>
                  <p className="p3">{t("home.apple.store")}</p>
                </div>
              </Button>
            </div>
          </div>

          <div className="landing-footer__links">
            <button type="button" onClick={() => navigate("restaurants")}>
              {t("landing.nav.forRestaurants")}
            </button>
            <button type="button" onClick={() => navigate("consumers")}>
              {t("landing.nav.forConsumers")}
            </button>
            <button type="button" onClick={() => navigate("companies")}>
              {t("landing.nav.forCompanies")}
            </button>
            <button type="button" onClick={() => navigate("about")}>
              {t("meta.landingAbout")}
            </button>
            <button type="button" onClick={() => navigate("support")}>
              {t("utils.common.support")}
            </button>
          </div>

          <div className="landing-footer__social">
            <a
              href="https://www.linkedin.com/company/offood"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
            <a
              href="https://www.instagram.com/offood.ch"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              href="https://www.facebook.com/share/18Dtc1TXa9/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
          </div>
        </div>

        <div className="landing-footer__bottom">
          <div className="landing-footer__company">
            <div>Offood SARL</div>
            <div>Chemin de la Gradelle 28, 1224 Chêne-Bougeries (Suisse)</div>
            <div>CHE-220.857.944</div>
          </div>

          <div className="landing-footer__legal">
            <button
              type="button"
              onClick={() => navigate("termsAndConditions")}
            >
              {t("home.footer.termsAndConditions")}
            </button>
            <button type="button" onClick={() => navigate("consentAndCookies")}>
              {t("home.footer.consentAndCookies")}
            </button>
            <button type="button" onClick={() => navigate("legalMentions")}>
              {t("home.footer.legalMentions")}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default LandingFooter;
